import { render } from "./UserBatchDelete.vue?vue&type=template&id=8a9c0140&scoped=true"
import script from "./UserBatchDelete.vue?vue&type=script&lang=js"
export * from "./UserBatchDelete.vue?vue&type=script&lang=js"

import "./UserBatchDelete.vue?vue&type=style&index=0&id=8a9c0140&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a9c0140"]])

export default __exports__